const catastropheBondsCollateralPoolAddress_Fuji = "0x7e2F65C4f45Ad93065284Ce75830166211c7eC3b";
const catastropheBondsFactoryAddress_Fuji = "0x26D9E84527D1FED9eA3eC680366E4f9A69530e16";
const catastropheBondsCollateralPoolAddress_Amoy = "0xec2B803E708F5bCcEA23d16CB74a97237600d17B";
const catastropheBondsFactoryAddress_Amoy = "0xDCe893395b07FBE2D546631304F1C552092245b7";

const rpcUrl_Fuji = "https://api.avax-test.network/ext/bc/C/rpc";
const rpcUrl_Amoy = "https://rpc-amoy.polygon.technology";

const ccipRouterAddress_Fuji = "0xF694E193200268f9a4868e4Aa017A0118C9a8177";
const ccipRouterAddress_Amoy = "0x9C32fCB86BF0f4a1A8921a9Fe46de3198bb884B2";

const chainSelector_Fuji = "14767482510784806043";
const chainSelector_Amoy = "16281711391670634445";

const usdcTokenAddress_Fuji = "0x5425890298aed601595a70AB815c96711a31Bc65";
const usdcTokenAddress_Amoy = "0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582";

const linkTokenAddress_Fuji = "0x0b9d5D9136855f6FEc3c0993feE6E9CE8a297846";
const linkTokenAddress_Amoy = "0x0Fd9e8d3aF1aaee056EB9e802c3A762a667b1904";

export {
    catastropheBondsCollateralPoolAddress_Fuji,
    catastropheBondsFactoryAddress_Fuji,
    catastropheBondsCollateralPoolAddress_Amoy,
    catastropheBondsFactoryAddress_Amoy,
    rpcUrl_Fuji,
    rpcUrl_Amoy,
    ccipRouterAddress_Fuji,
    ccipRouterAddress_Amoy,
    chainSelector_Fuji,
    chainSelector_Amoy,
    usdcTokenAddress_Fuji,
    usdcTokenAddress_Amoy,
    linkTokenAddress_Fuji,
    linkTokenAddress_Amoy
}